module.exports = __webpack_public_path__ + "about-us-b998e096/empty-state-icon-36f94ae2ae65fa6c029b379818a25766.svg";